import InfoPreview from "@common/controls/InfoPreview/component";
import { InlinePreloader } from "@common/controls/Preloader/component";
import { useI18n } from "@common/hooks/i18n";
import { usePromise } from "@common/lib/hooks";
import { isVisible } from "@common/lib/misc";
import { type Account } from "@common/modules/account/types";
import React from "react";
import { type AddEditRecipientGetDynamicFields } from "../AddUpdateModal";

type Props = {
  bankName: string | null | undefined;
  beneficiaryId: string;
  data: Account.Api.WiseBeneficiaryData;
  currencyCode: string;
  getDynamicFields: AddEditRecipientGetDynamicFields;
  style?: React.CSSProperties;
};
const BankRecipientPreview = (props: Props) => {
  const i18n = useI18n();

  const [recipientAdditionalData, isLoadingRecipientAdditionalData] = usePromise({
    fn: props.getDynamicFields!,
    args: [{ recipientId: props.beneficiaryId, currencyCode: props.currencyCode }],
    shouldLoad: true
  });

  const fields = React.useMemo(
    () =>
      (recipientAdditionalData?.fields ?? []).filter((x) =>
        isVisible(
          x.visibilityCondition,
          recipientAdditionalData!.fields.reduce((res, x) => ({ ...res, [x.name]: x.value }), {})
        )
      ),
    [recipientAdditionalData?.fields]
  );

  if (isLoadingRecipientAdditionalData) return <InlinePreloader />;

  return (
    <InfoPreview style={props.style}>
      <InfoPreview.Line label={i18n.currency} value={props.currencyCode} />

      {!fields.some((x) => x.name === "bankName") && <InfoPreview.Line label={i18n.bankName} value={props.bankName} />}

      {fields.map((x) => (
        <InfoPreview.Line key={x.name} label={x.label!} value={x.value} />
      ))}

      {!!props.data.additionalData.accountType && (
        <InfoPreview.Line label={i18n.accountType} value={props.data.additionalData.accountType} />
      )}

      {!!props.data.additionalData.branchCode && (
        <InfoPreview.Line label={i18n.branchCode} value={props.data.additionalData.branchCode} />
      )}
    </InfoPreview>
  );
};
export default BankRecipientPreview;
